import React from "react";
import { Group as MGroup, Text, Divider, Button, Tooltip, Menu, Badge } from "@mantine/core";
import { FiChevronDown, FiCheck } from "react-icons/fi";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  selectRfpSpecifiedRows,
  selectActiveSpecifiedItem,
  selectActiveRoomColoringId,
} from "../RFPBarSelectors";
import { setActiveRoomColoringIdThunk } from "../../designThunk";

const makePlaceholder = (w = 14) => <span style={{ width: w, display: "inline-block" }} />;

export const RFPBarSpecifiedArticlesSection: React.FC = () => {
  const dispatch = useAppDispatch();

  const specifiedRows = useAppSelector(selectRfpSpecifiedRows);
  const activeSpecifiedItem = useAppSelector(selectActiveSpecifiedItem);
  const activeRoomColoringId = useAppSelector(selectActiveRoomColoringId);

  return (
    <MGroup gap="sm" align="center" wrap="nowrap">
      <Divider orientation="vertical" h={24} />

      <Text size="sm" c="dimmed">
        Artikkelvalidering
      </Text>

      <Menu withinPortal position="bottom-start" shadow="md" width={420}>
        <Menu.Target>
          <Tooltip
            label={
              activeSpecifiedItem
                ? `Aktiv: ${activeSpecifiedItem.title}`
                : "Velg romfargelegging for artikkelvalidering"
            }
            position="bottom"
            withArrow
            openDelay={250}
          >
            <Button
              size="sm"
              radius="xl"
              variant={activeSpecifiedItem ? "filled" : "subtle"}
              color="blue"
              rightSection={<FiChevronDown size={14} />}
              style={{ paddingLeft: 14, paddingRight: 12, fontWeight: 600 }}
              disabled={specifiedRows.length === 0}
            >
              <MGroup gap={8} wrap="nowrap">
                <Text size="sm" fw={600}>
                  Filter
                </Text>

                {activeSpecifiedItem ? (
                  <Badge
                    variant={activeSpecifiedItem ? "white" : "light"}
                    size="sm"
                    style={{ textTransform: "none" }}
                  >
                    {activeSpecifiedItem.title}
                  </Badge>
                ) : null}
              </MGroup>
            </Button>
          </Tooltip>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item
            onClick={() => dispatch(setActiveRoomColoringIdThunk(undefined))}
            leftSection={!activeSpecifiedItem ? <FiCheck size={14} /> : makePlaceholder()}
          >
            <Text size="sm">Ingen artikkelfilter</Text>
          </Menu.Item>

          <Menu.Divider />

          {specifiedRows.map((item) => {
            const isSelected = item.id === activeRoomColoringId;
            return (
              <Menu.Item
                key={item.id}
                onClick={() => dispatch(setActiveRoomColoringIdThunk(item.id))}
                leftSection={isSelected ? <FiCheck size={14} /> : makePlaceholder()}
                rightSection={isSelected ? <Badge size="xs">Aktiv</Badge> : null}
              >
                <Text size="sm" truncate>
                  {item.title}
                </Text>
              </Menu.Item>
            );
          })}
        </Menu.Dropdown>
      </Menu>
    </MGroup>
  );
};
